import { useEffect } from 'react';

/**
 * Lock body scroll while the form runtime is mounted (saas-1.23.B).
 * Adds `form-runtime-active` class to <body> on mount, removes on unmount.
 * Pair with `body.form-runtime-active { overflow: hidden; height: 100dvh }` in styles.css.
 *
 * @param active - true = lock body scroll; false = noop (e.g. editor preview)
 */
export function useLockBodyScroll(active: boolean) {
  useEffect(() => {
    if (!active) return;
    document.body.classList.add('form-runtime-active');
    return () => document.body.classList.remove('form-runtime-active');
  }, [active]);
}
